"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    suggestionChipDefaultVariants: ()=>suggestionChipDefaultVariants,
    suggestionChipSlots: ()=>suggestionChipSlots
});
const suggestionChipSlots = {
    containerSlot: 'antialiased flex items-center border border-solid px-2 rounded-action-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-8 focus-visible:ring-offset-2',
    leadingIconSlot: '',
    trailingIconSlot: '',
    labelTextSlot: 'p-1',
    countSlot: 'pr-1'
};
const suggestionChipDefaultVariants = {
    emphasis: 'regular'
};
exports.suggestionChipDefaultVariants = __webpack_exports__.suggestionChipDefaultVariants;
exports.suggestionChipSlots = __webpack_exports__.suggestionChipSlots;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "suggestionChipDefaultVariants",
    "suggestionChipSlots"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
